import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { HoardingShowcase } from '../components/HoardingShowcase';
import { About } from '../components/About';
import { Services } from '../components/Services';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { PortfolioGallery } from '../components/PortfolioGallery';
import { Clients } from '../components/Clients';
import { EventManagement } from '../components/EventManagement';
import { ContactForm } from '../components/ContactForm';
import { Footer } from '../components/Footer';
import { WhatsAppButton } from '../components/WhatsAppButton';
import { Toaster } from '../components/ui/sonner';

const Home = () => {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>In Smart Media - Solapur's Leading Advertising & Digital Marketing Agency</title>
        <meta name="description" content="In Smart Media is Solapur's trusted advertising agency with 17+ years of experience. We offer E-Rickshaw branding, hoardings, social media marketing, radio/TV ads, digital marketing & more. 500+ successful campaigns delivered." />
        <meta name="keywords" content="advertising agency Solapur, digital marketing Solapur, E-Rickshaw branding, hoarding advertising, social media marketing, radio advertising, TV advertising, print media, holography advertising, brand promotion Solapur, In Smart Media, outdoor advertising Solapur" />
        <link rel="canonical" href="https://www.insmartmedia.com/" />
      </Helmet>
      <Navbar />
      <Hero />
      <HoardingShowcase />
      <About />
      <PortfolioGallery />
      <Services />
      <WhyChooseUs />
      <Clients />
      <EventManagement />
      <ContactForm />
      <Footer />
      <WhatsAppButton />
      <Toaster />
    </div>
  );
};

export default Home;
